import React from "react";

export interface MapState {
  isProfileOpen: boolean;
  setIsProfileOpen: React.Dispatch<React.SetStateAction<boolean>>;
  mapPlaceId: string | null;
  setMapPlaceId: React.Dispatch<React.SetStateAction<string | null>>;
  mapCenter: { lat: number; lng: number };
  setMapCenter: React.Dispatch<
    React.SetStateAction<{ lat: number; lng: number }>
  >;
  zoom: number;
  setZoom: React.Dispatch<React.SetStateAction<number>>;
}

export const useMapState = (
  latitude?: number,
  longitude?: number,
  zm?: number,
): MapState => {
  const [isProfileOpen, setIsProfileOpen] = React.useState(false);
  const [mapPlaceId, setMapPlaceId] = React.useState<string | null>(null);
  const [mapCenter, setMapCenter] = React.useState<{
    lat: number;
    lng: number;
  }>({
    lat: latitude ? latitude : 40.712,
    lng: longitude ? longitude : -74.006,
  });
  const [zoom, setZoom] = React.useState(zm ? zm : 14);

  return React.useMemo(
    () => ({
      isProfileOpen,
      setIsProfileOpen,
      mapPlaceId,
      setMapPlaceId,
      mapCenter,
      setMapCenter,
      zoom,
      setZoom,
    }),
    [isProfileOpen, mapPlaceId, mapCenter, zoom],
  );
};
